export const iconFontAwesomeAutomotiveTaxi = (
	<i className="fa-solid fa-taxi"></i>
);
